import React from 'react';
import PropTypes from 'prop-types';

import { CircularLoading } from '../CircularLoading';
import { PageContent } from '../PageContent';
import { Flex } from '../Flex';
import { CircularProgress } from '@mui/material';

const LoadingFallback = ({ isBlue = false, fullPage = false }) => {
  // When fullPage is true, use CircularLoading (for App.jsx initial load)
  if (fullPage) {
    return <CircularLoading />;
  }

  // Otherwise, render within PageContent with MUI CircularProgress
  return (
    <>
      <PageContent isBlue={isBlue}>
        <Flex
          sx={{
            height: '100%',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '400px',
          }}
        >
          <CircularProgress size={56} />
        </Flex>
      </PageContent>
    </>
  );
};

LoadingFallback.propTypes = {
  isBlue: PropTypes.bool,
  fullPage: PropTypes.bool,
};

export default LoadingFallback;
